<template>
  <v-app>
    <router-view @msj="msj" />
    <v-snackbar
      v-model="alerta.estado"
      :color="alerta.color"
      :timeout="5000"
      bottom
      right
    >
      {{ alerta.text }}
      <template v-slot:action="{ attrs }">
        <v-btn icon dark text @click="alerta.estado = false" v-bind="attrs">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
export default {
  name: 'app',
  data: () => ({
    alerta: {
      estado: false,
      color: null,
      text: null,
    },
  }),
  methods: {
    msj(text, color) {
      this.alerta.estado = true
      this.alerta.text = text
      this.alerta.color = color ? `${color} darken-3` : 'red darken-3'
    },
  },
}
</script>
